module.exports = __webpack_public_path__ + "img/flow-04.5a861030.svg";